import {useEffect, useState} from 'react';
import Fortress from '../../services/fortress/Fortress';

const useLtxToken = (subscribeToTokenChange = false) => {
  const [ltxTokenInitialized, setLtxTokenInitialized] = useState(false);
  const [ltxToken, setLtxToken] = useState<string | null | undefined>(null);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;

    (async () => {
      const userLtxToken = await Fortress.getAccessToken();
      setLtxToken(userLtxToken);
      setLtxTokenInitialized(true);
      if (subscribeToTokenChange) {
        unsubscribe = Fortress.addSubscriber(
          Fortress.SAVE_FORTRESS_COOKIES,
          async () => {
            const newLtxToken = await Fortress.getAccessToken();
            setLtxToken(newLtxToken);
          }
        );
      }
    })();

    return () => {
      if (subscribeToTokenChange) {
        unsubscribe?.();
      }
    };
  }, [subscribeToTokenChange]);

  return {
    ltxToken,
    setLtxToken,
    ltxTokenInitialized,
  };
};

export default useLtxToken;
